import React from 'react'

const UserManageIcon = ({
  size = 24, 
  color = "currentColor",  
  strokeWidth = 1.5 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M9.51408 14.7071C12.6415 14.6991 15.3007 16.135 16.2782 19.2261C14.308 20.4272 11.9889 20.8898 9.51408 20.8837C7.03921 20.8898 4.72016 20.4272 2.75 19.2261C3.72857 16.1317 6.38327 14.6991 9.51408 14.7071Z" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
      <path 
        d="M16.0852 18.2321C17.975 18.2367 19.7458 17.8835 21.2502 16.9664C20.5039 14.606 18.4733 13.5095 16.0852 13.5157C14.5809 13.5118 13.2205 13.9435 12.2324 14.8529" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
      <circle 
        cx="9.51421" 
        cy="7.3521" 
        r="4.23687" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
      <path 
        d="M13.7143 5.67014C14.3046 5.05148 15.1371 4.66602 16.0597 4.66602C17.8498 4.66602 19.301 6.11718 19.301 7.90729C19.301 9.69739 17.8498 11.1486 16.0597 11.1486C14.9654 11.1486 13.9978 10.6063 13.4109 9.77575" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
    </svg>
  )
}

export default UserManageIcon